import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export interface AnalyticsChartProps {
  chartData: Array<{
    date: string;
    pv: number;
    uu: number;
    totalSwipes: number;
    cv: number;
    cvr: number;
    ctaClicks: number;
  }>;
  viewType: 'daily' | 'monthly';
}

export const AnalyticsChart: React.FC<AnalyticsChartProps> = ({ chartData, viewType }) => {
  return (
    <Box sx={{ mb: 3, px: 3 }}>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#000000', mb: 2 }}>
        指標推移
      </Typography>
      <Box sx={{ backgroundColor: '#F5F5F5', borderRadius: '12px' }}>
        {/* 凡例をグラフの外に配置 */}
        <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 12, height: 12, backgroundColor: '#FFC107', borderRadius: '2px' }} />
            <Typography sx={{ fontSize: '12px', color: '#000000' }}>PV</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 12, height: 12, backgroundColor: '#FF9800', borderRadius: '2px' }} />
            <Typography sx={{ fontSize: '12px', color: '#000000' }}>UU</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 12, height: 12, backgroundColor: '#F44336', borderRadius: '2px' }} />
            <Typography sx={{ fontSize: '12px', color: '#000000' }}>総スワイプ数</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 12, height: 12, backgroundColor: '#00BCD4', borderRadius: '2px' }} />
            <Typography sx={{ fontSize: '12px', color: '#000000' }}>CTAクリック数</Typography>
          </Box>
        </Box>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E0E0E0" horizontal={true} vertical={false} />
            <XAxis
              dataKey="date"
              stroke="#666666"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="#666666"
              style={{ fontSize: '12px' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E0E0E0',
                borderRadius: '8px',
                fontSize: '12px',
              }}
            />
            <Line
              type="monotone"
              dataKey="pv"
              name="PV"
              stroke="#FFC107"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 6, strokeWidth: 2 }}
              legendType="none"
            />
            <Line
              type="monotone"
              dataKey="uu"
              name="UU"
              stroke="#FF9800"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 6, strokeWidth: 2 }}
              legendType="none"
            />
            <Line
              type="monotone"
              dataKey="totalSwipes"
              name="総スワイプ数"
              stroke="#F44336"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 6, strokeWidth: 2 }}
              legendType="none"
            />
            <Line
              type="monotone"
              dataKey="ctaClicks"
              name="CTAクリック数"
              stroke="#00BCD4"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 6, strokeWidth: 2 }}
              legendType="none"
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

